import { render, staticRenderFns } from "./adminform.vue?vue&type=template&id=8957e514&"
import script from "./adminform.vue?vue&type=script&lang=js&"
export * from "./adminform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports